<mat-card class="cur-card">
  <mat-card-header>
    <mat-card-title>預り金一覧（１年経過）</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="table-responsive" style="max-height: 537px;">
      <table mat-table [dataSource]="dataSource" matSort style="min-width: 1248px;" #sort1="matSort">
        <ng-container matColumnDef="select">
          <th mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
            style="min-width: 2em; width: 2em;">
            対象</th>
          <td mat-cell *matCellDef="let row" class=" text-center">
            <mat-checkbox color="primary" (change)="$event ? selectionToggle(row) : null;"
              [checked]="selection.isSelected(row)" (dblclick)="$event?.stopPropagation()">
            </mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="payCtrNo">
          <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 95px;">
            支払契約番号</th>
          <td mat-cell *matCellDef="let row">{{ row.payCtrNo }}</td>
        </ng-container>
        <ng-container matColumnDef="visitName">
          <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 85px;">
            請求先名</th>
          <td mat-cell *matCellDef="let row">{{ row.visitName }}</td>
        </ng-container>
        <ng-container matColumnDef="receivemoneydate">
          <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 75px;">
            入金日
          </th>
          <td mat-cell *matCellDef="let row">{{ row.receivemoneydate | dateString}}</td>
        </ng-container>
        <ng-container matColumnDef="kinkoAmt">
          <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 105px;">
            未精算額[円]</th>
          <td mat-cell *matCellDef="let row" class="text-right">{{ row.kinkoAmt | number }}</td>
        </ng-container>
        <ng-container matColumnDef="rcvmnyKeitai">
          <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 85px;">
            入金形態</th>
          <td mat-cell *matCellDef="let row">{{ row.rcvmnyKeitai }}</td>
        </ng-container>
        <ng-container matColumnDef="rcvmnyFclt">
          <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 140px;">
            入金機関</th>
          <td mat-cell *matCellDef="let row">{{ row.rcvmnyFclt }}</td>
        </ng-container>
        <ng-container matColumnDef="kinkoOccurrenceYearmonthdate">
          <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 115px;">
            未精算発生年月日</th>
          <td mat-cell *matCellDef="let row">{{ row.kinkoOccurrenceYearmonthdate | dateString }}</td>
        </ng-container>
        <ng-container matColumnDef="kinkoSts">
          <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 115px;">
            未精算ステータス</th>
          <td mat-cell *matCellDef="let row">{{ row.kinkoSts }}</td>
        </ng-container>
        <ng-container matColumnDef="kinkoReason">
          <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 115px;">
            未精算理由</th>
          <td mat-cell *matCellDef="let row">{{ row.kinkoReason }}</td>
        </ng-container>
        <ng-container matColumnDef="funoReason">
          <th mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef>
            不能理由</th>
          <td mat-cell *matCellDef="let row; let i = index">
            <textarea maxlength="256" matInput rows="1" (ngModelChange)="onChangeReason(row, $event)"
              (dblclick)="$event?.stopPropagation()" [(ngModel)]="row.funoReason" autocomplete="off"
              [disabled]="isTexareaDisabled(row)" [style]="getTextareaStyle(row)"
              style="min-width: 285px; max-width: 285px;"></textarea>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumnsCol; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsCol" [class]="'clickable-mat-row'"
          (dblclick)="onDblClickRow(row, $event)">
        </tr>
      </table>
    </div>
    <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
      <mat-card-actions class="btn_area_right">
        <button type="button" (click)="onClickRegist()" mat-raised-button [disabled]="isRegistButtonInvalid()"
          color="primary" class="btn">登録</button>
        <button type="button" (click)="onClickCancel()" mat-raised-button [disabled]="isDeleteButtonInvalid()"
          color="primary" class="btn">取消</button>
      </mat-card-actions>
    </div>
  </mat-card-content>
</mat-card>